export const BASE_URL = `${process.env.REACT_APP_API_SURVEY_ENDPOINT}/${process.env.REACT_APP_API_SURVEY_VERSION}`;
export const BACKEND_URL = `${process.env.REACT_APP_API_ENDPOINT}/${process.env.REACT_APP_API_VERSION}`;
